import "../utilities/globals/index.js";
export { ApolloProvider, ApolloConsumer, getApolloContext, resetApolloContext, } from "./context/index.js";
export * from "./hooks/index.js";
export { DocumentType, operationName, parser } from "./parser/index.js";
export { createQueryPreloader } from "./query-preloader/createQueryPreloader.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/index.js
// module id = 2138
// module chunks = 11